import { httpsCallable, type Functions } from 'firebase/functions';

/** Requests synchronization of an active public novel mirror. */
export async function synchronizePublishedNovel(functions: Functions, ownerId: string, novelId: string): Promise<void> {
  try {
    const synchronize = httpsCallable<{ ownerId: string; novelId: string }, unknown>(functions, 'synchronizePublishedNovel');
    await synchronize({ ownerId, novelId });
  } catch (error) {
    console.warn('Failed to synchronize published novel:', error);
  }
}

/** Requests synchronization of the authenticated user's public author mirror. */
export async function synchronizePublicAuthor(functions: Functions): Promise<void> {
  try {
    const synchronize = httpsCallable<Record<string, never>, unknown>(functions, 'synchronizePublicAuthor');
    await synchronize({});
  } catch (error) {
    console.warn('Failed to synchronize public author:', error);
  }
}